import { apiProxyRequest } from "Api/apiProxyRequest";

export const deleteProfilePictureRequest = (userId: string) =>
  apiProxyRequest<undefined>(`/profile/${userId}/picture`, "DELETE");
